export default __webpack_public_path__ + "static/media/photo10.5b0cab17.jpg";